module.exports = ol.geom.Geometry;